import { render, staticRenderFns } from "./priceManaged.vue?vue&type=template&id=a6b7e792&"
import script from "./priceManaged.vue?vue&type=script&lang=js&"
export * from "./priceManaged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports